import styled from "styled-components";
import { Icon } from "@evertrue/et-components";

export const CustomDragHandle = styled(Icon)`
  cursor: move;
`;
